// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"PageNotFound_mainContainer__3ZRIz","imgContainer":"PageNotFound_imgContainer__3hnjz","img":"PageNotFound_img__3ufFn","btnHolder":"PageNotFound_btnHolder__2wwur"};